const DATABASE = 'graphite-sqlite-files';
const STORE = 'files';

function openStore(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function readDatabase(name: string): Promise<Uint8Array | null> {
  const db = await openStore();
  return new Promise((resolve, reject) => {
    const request = db.transaction(STORE).objectStore(STORE).get(name);
    request.onsuccess = () => resolve(request.result instanceof Uint8Array ? request.result : null);
    request.onerror = () => reject(request.error);
  });
}

export async function writeDatabase(name: string, bytes: Uint8Array): Promise<void> {
  const db = await openStore();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE, 'readwrite');
    transaction.objectStore(STORE).put(bytes, name);
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
  });
}

